export const FASTPREVIEW_START = 'fastpreview/fastpreview-start';
export const FASTPREVIEW_GET_RESULT = 'fastpreview/fastpreview-get-result';
export const FASTPREVIEW_GET_RESULT_TABLE =
  'fastpreview/fastpreview-get-result-table';
export const FASTPREVIEW_CLEAR = 'fastpreview/fastpreview-clear';
